import { ErrorMsg } from "../constants/errormessages.constant";
import { createBrowserHistory } from 'history';

export const makeApiCall = async function (
  dispatch,
  api,
  successDispatchType,
  errorDispatchType,
  apiType,
  extraData
) {
  try {
    let res = await api;
    if (typeof res === "function") {
      return;
    }
    if (res) {
      dispatch({
        type: successDispatchType,
        status: "SUCCESS",
        data: apiType === "post" ? res.data : res.data.Data,
        message: apiType === "post" ? "res.Message" : res.data.Message,
        extraData
      });
      return res;
    }
  } catch (err) {
    let errorMsg = "";
    if (err.response !== undefined && err.response.status !== 500) {
      errorMsg = err.response;
    } else {
      errorMsg = {
        data: {
          StatusCode: "",
          Error: ErrorMsg.CONNECTION_ERROR,
          connectionError: true
        }
      };
    }
    dispatch({
      type: errorDispatchType,
      status: "FAILURE",
      error: errorMsg,
      extraData
    });
    return errorMsg;
  }
};

export const History = createBrowserHistory();
